'use strict';

export default class AvailabilityBarComponent {
	public restrict: any;
	public scope: any;
	public template: any;
	public controller: any;
	public controllerAs: any;
	public bindToController: any;

  constructor() {
    this.restrict = 'E',
    this.scope = {
      onlineservice: '='
    }
    this.template = require('./bar.component.html');

    this.controller = AvailabilityBarController;
    this.controllerAs = 'ctrl';
    this.bindToController = true;
  }
}

//availabilityBar
/* @ngInject */
class AvailabilityBarController {
	public $scope: any;
	public $state: any;

  constructor($scope, $state) {
    this.$scope = $scope;
    this.$state = $state;
  }

  switch() {
    this.$state.go('main.availability');
  }
}